//email history constants
export const otpFrom = {
  SIGNIN: 'signin',
  SIGNUP: 'signup',
  RESET_PASSWORD: 'resetPassword',
  ENABLE_PASSWORD: 'enablePassword',
};
